import { render, staticRenderFns } from "./GrantPaymentSetup.vue?vue&type=template&id=402f4a76&"
import script from "./GrantPaymentSetup.vue?vue&type=script&lang=js&"
export * from "./GrantPaymentSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports